import * as d3 from 'd3';
import * as _ from 'lodash';
import { behavior } from 'd3';
function directive($window, timeFormat, $state, $stateParams) {
    return  {
        transclude: true,
        require: '^lateralmap',
        template: require('./sidebar_view.html'),
        link: function ($scope, element, attrs, lmCtrl) {
            /////////////////
            /// VARIABLES ///
            ///////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------
                // Window Dimensions
                    lmCtrl.max_width = element[0].clientWidth,
                    lmCtrl.height = angular.element($window)[0].innerHeight - 150,
                    lmCtrl.width = lmCtrl.max_width * 0.76,
                    lmCtrl.sidebar_width = lmCtrl.max_width * 0.22,
                    lmCtrl.tempWidth = lmCtrl.width;

                // local settings saved if a user changed it
                if (lmCtrl.settings.get('lateral_chart_settings')) {
                    if (lmCtrl.settings.get('lateral_chart_settings')[0]) {
                        lmCtrl.gravity = lmCtrl.settings.get('lateral_chart_settings')[0];
                    }
                    if (lmCtrl.settings.get('lateral_chart_settings')[1]) {
                        lmCtrl.charge = lmCtrl.settings.get('lateral_chart_settings')[1];
                    }
                    if (lmCtrl.settings.get('lateral_chart_settings')[2]) {
                        lmCtrl.link_distance = lmCtrl.settings.get('lateral_chart_settings')[2];
                    }
                    if (lmCtrl.settings.get('lateral_chart_settings')[3]) {
                        lmCtrl.link_strength = lmCtrl.settings.get('lateral_chart_settings')[3];
                    }
                    if (lmCtrl.settings.get('lateral_chart_settings')[4]) {
                        lmCtrl.friction = lmCtrl.settings.get('lateral_chart_settings')[4];
                    }
                    if (lmCtrl.settings.get('lateral_chart_settings')[5]) {
                        lmCtrl.padding = lmCtrl.settings.get('lateral_chart_settings')[5];
                    }
                }
                // lmCtrl.alpha = lmCtrl.settings.get('lateral_chart_settings')[5];
                // lmCtrl.maxRadius = lmCtrl.settings.get('lateral_chart_settings')[6];

                // SLIDER SETTINGS
                    // slider settings for the 'settings' section in the sidebar
                    let offsetX = 15,
                    offsetY = 40,
                    slider_radius = 10,
                    slider_height = 15;
                    // need to specify width for sidebar SVGs
                    let max_x = (lmCtrl.sidebar_width-(offsetX*4)),
                    old_max_x;
                    // array of sliders
                    let sliders = [
                        { name:"gravity", min:0.0001, max:1, x:0, y:0, default:lmCtrl.gravity },
                        { name:"charge", min:-5000, max:-1, x:0, y:0, default:lmCtrl.charge },
                        { name:"link_distance", min:1, max:500, x:0, y:0, default:lmCtrl.link_distance },
                        { name:"link_strength", min:0.0001, max:1, x:0, y:0, default:lmCtrl.link_strength },
                        { name:"friction", min:0.0001, max:1, x:0, y:0, default:lmCtrl.friction },
                        { name:"padding", min:2, max:50, x:0, y:0, default:lmCtrl.padding },
                        // { name:"alpha", min:0.001, max:0.9, x:0, y:0, default:lmCtrl.alpha },
                        // { name:"radius", min:5, max:20, x:0, y:0, default:lmCtrl.maxRadius },
                    ]

                // COLLAPSE
                    // collision section (4 circles to select)
                    let collapse_hide = 0; // 0 = select, 1 = collapse, 2 = hide, 3 = only show
                    let background_radius = 18;
                    // array of different type of collapse (grouping)
                    let circles_collapse = [
                        { value:0, name: "Select", offsetX:background_radius + 2 },
                        { value:1, name: "Collapse", offsetX:((max_x / 3) + (background_radius)) },
                        { value:2, name: "Hide", offsetX:(((max_x * 2) / 3) + (background_radius / 2)) },
                        { value:3, name: "Show", offsetX:(max_x) },
                    ]

                    // When a Collpased node is created, this is the default blank object
                    let defaultCollapsedNode = {
                        id: false,
                        ip : [],
                        hostname : [],
                        connections : [],
                        mac : [],
                        os : [],
                        vendor : [],
                        group : [],
                        group_name : [],
                        type : [],
                        resp_l7 : [],
                        orig_l7 : [],
                        collapse : true,
                        action : false,
                        ioc : 0,
                        weight : 0,
                        selected : false,
                        grey : false,
                        visible : true,
                        radius : (lmCtrl.maxRadius*2),
                        x : lmCtrl.width / 2,
                        y : lmCtrl.height / 2,
                        px : lmCtrl.width / 2,
                        py : lmCtrl.height / 2,
                    }

                    // used for sorting the sidear node info (what columns and direction)
                    let temp_sort = "weight";
                    let desc = true;

                // $SCOPE VARIABLES (so they can interact with angular)
                    $scope.groups = {};    // object of all the possible groups available
                    // $scope.show_info = true; // display the node info titles (when zero hide title)

                    // Array of all the possible Node Types
                    $scope.types = ['Access Point','Database','Desktop','DHCP Server','DNS Server', 'Domain Controller','Endpoint','File Server','Gateway','Laptop','Mobile','Phone','Printer','Server','Switch','Web Server'];
                    // The current group and node group & type used for sidebar
                    $scope.current = {
                        node : {
                            ip: "",
                            type: "N/A",
                            group: "N/A"
                        },
                        group : {
                            id : false,
                            name: "",
                            color: "#000000"
                        }
                    }
                    $scope.showSelectAll = true;
                    $scope.selected_nodes = [];
                    // object for the bandwidth dropdown in the settings section of the sidebar
                    $scope.diff_bandwidth = {
                        b : {select : "b", value : 1, text: "Bytes", acronym:"B"},
                        kb : {select : "kb", value : 1024, text: "Kilobytes", acronym:"KB"},
                        mb : {select : "mb", value : 1048576, text: "Megabytes", acronym:"MB"},
                        gb : {select : "gb", value : 1073741824, text: "Gigabyte", acronym:"GB"},
                        tb : {select : "tb", value : 1099511627776, text: "Terabyte", acronym:"TB"},
                    }
                    // the current bandwidth selected
                    $scope.bandwidth = "mb";
                    if (lmCtrl.settings.get('lateral_chart_bandwidth')) {
                        $scope.bandwidth = lmCtrl.settings.get('lateral_chart_bandwidth');
                    }
                    // Object for the node info limit (max number of nodes to be displayed)
                    $scope.sidebar_limits = [
                        {value : 0, text : "0"},
                        {value : 5, text : "5"},
                        {value : 20, text : "20"},
                        {value : 50, text : "50"},
                        {value : 100, text : "100"},
                        {value : 1000, text : "1000"},
                        {value : false, text : "No Limit"},
                    ];
                    // the selected node info limit
                    $scope.max_rows = "false";
                    if (lmCtrl.settings.get('lateral_chart_max_rows')) {
                        $scope.max_rows = lmCtrl.settings.get('lateral_chart_max_rows');
                    }
                    $scope.display_ip = "true";
                    if (lmCtrl.settings.get('display_ip')) {
                        $scope.display_ip = lmCtrl.settings.get('display_ip');
                    }
                    $scope.display_hostname = false;
                    if (lmCtrl.settings.get('display_hostname')) {
                        $scope.display_hostname = lmCtrl.settings.get('display_hostname');
                    }
                    $scope.hide_on_search = false;
                    if (lmCtrl.settings.get('hide_on_search')) {
                        $scope.hide_on_search = lmCtrl.settings.get('hide_on_search');
                    }
            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

            //////////////
            /// EVENTS ///
            ////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------
                // Gets all the groups from the controller
                // Once group is saved in the back end, it then has to save it for the current page
                lmCtrl.setGroups = function (groups) {
                    let g;
                    for (g in groups) {
                        $scope.groups[groups[g].id] = groups[g]
                    }
                }
            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

            ///////////////
            /// SIDEBAR ///
            /////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------------
                // SIDEBAR TOGGLE
                    // Sidebar SVGs and toggle for show / hide sidebar
                    let sidebar = d3.select("#sidebar").style("max-width",lmCtrl.sidebar_width+"px");
                    let sidebar_svg = d3.select("#sidebar #sidebr_svg").attr("height", "0").attr("width", lmCtrl.sidebar_width).attr("stroke-width", "0")
                    let sidebar_content = d3.select("#sidebar_content").style("max-height", (lmCtrl.height-50)+"px")

                    let arrow_title = d3.selectAll(".arrow_title").append("svg").attr("height", "24").attr("width", "24").attr("fill", "#333333").append("path").attr('d', "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z")

                    $scope.toggleShow = function (divID) {
                        if (d3.select("#"+divID+"_content").classed("hide_section")) {
                            d3.select("#"+divID+"_content").classed("hide_section", false)
                            d3.select("#"+divID+" .sidebar_title").classed("selected", true)
                            d3.select("#"+divID+" .arrow_title svg path").attr('d', "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z");
                        } else {
                            d3.select("#"+divID+"_content").classed("hide_section", true)
                            d3.select("#"+divID+" .sidebar_title").classed("selected", false)
                            d3.select("#"+divID+" .arrow_title svg path").attr('d', "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z");
                        }
                        lmCtrl.drawSidebar();
                    }

                    $scope.toggleSidebar = function (divID) {
                        if (d3.select("#"+divID).classed("hide_section")) {
                            d3.select("#"+divID).classed("hide_section", false)
                            d3.select("#sidebar_collapse").classed("hide_section", true)
                        } else {
                            d3.select("#sidebar_collapse").classed("hide_section", false)
                            d3.select("#"+divID).classed("hide_section", true)
                        }
                        lmCtrl.resize_map();
                    }

                // NODE INFO - list all nodes, shows L7 between nodes, shows selected node (if only 1 node selected)
                    let node_info = d3.select("#node_info_rows");

                    function sortBy(a,b) {
                        if (desc) {
                            if ((a[temp_sort] !== "N/A") && (b[temp_sort] === "N/A")) return 1
                            if (a[temp_sort] > b[temp_sort]) return -1;
                            if (a[temp_sort] < b[temp_sort]) return 1;
                        } else {
                            if ((a[temp_sort] !== "N/A") && (b[temp_sort] === "N/A")) return -1
                            if (a[temp_sort] < b[temp_sort]) return -1;
                            if (a[temp_sort] > b[temp_sort]) return 1;
                        }
                        return 0;
                    }
                    // sorts the sidebar depending on the column that is selected
                    $scope.sortBy = function (by) {
                        temp_sort = by;
                        lmCtrl.nodes.sort(sortBy)
                        if (desc) {
                            desc = false;
                        } else {
                            desc = true;
                        }
                        lmCtrl.drawSidebar();
                    }

                    // this function is to display the L7s between two IPs, and if no node is selected to just seleted the node
                    function between_two(elm, node) {
                        let obj = { resp: {}, orig: {}}, sel_ip, temp_sel_ip = [], temp_node_ip = [];
                        // creating the the L7 resp and orig to be able to tell the difference
                        if ($scope.selected_nodes.length === 1) {
                            sel_ip = $scope.selected_nodes[0].ip;
                            node = angular.copy(node);
                            if (typeof sel_ip === "string") {
                                temp_sel_ip.push(sel_ip)
                            } else {
                                temp_sel_ip = sel_ip;
                                sel_ip = false;
                            }
                            if (typeof node.ip === "string") {
                                temp_node_ip.push(node.ip)
                            } else {
                                temp_node_ip = node.ip;
                                node.ip = false;
                            }
                            for (let i in temp_node_ip) {
                                for (let si in temp_sel_ip) {
                                    if ((lmCtrl.l7_between_nodes[temp_sel_ip[si]]) && (lmCtrl.l7_between_nodes[temp_sel_ip[si]].resp[temp_node_ip[i]])) {
                                        for (let l7_resp in lmCtrl.l7_between_nodes[temp_sel_ip[si]].resp[temp_node_ip[i]]) {
                                            if (obj.resp[l7_resp]) {
                                                obj.resp[l7_resp].bytes += lmCtrl.l7_between_nodes[temp_sel_ip[si]].resp[temp_node_ip[i]][l7_resp].bytes
                                            } else {
                                                obj.resp[l7_resp] = lmCtrl.l7_between_nodes[temp_sel_ip[si]].resp[temp_node_ip[i]][l7_resp]
                                            }
                                        }
                                    }
                                    if ((lmCtrl.l7_between_nodes[temp_node_ip[i]]) && (lmCtrl.l7_between_nodes[temp_node_ip[i]].resp[temp_sel_ip[si]])) {
                                        for (let l7_orig in lmCtrl.l7_between_nodes[temp_node_ip[i]].resp[temp_sel_ip[si]]) {
                                            if (obj.orig[l7_orig]) {
                                                obj.orig[l7_orig].bytes += lmCtrl.l7_between_nodes[temp_node_ip[i]].resp[temp_sel_ip[si]][l7_orig].bytes
                                            } else {
                                                obj.orig[l7_orig] = lmCtrl.l7_between_nodes[temp_node_ip[i]].resp[temp_sel_ip[si]][l7_orig]
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        // TODO: REFACTOR THIS SHIT!
                        var arr_resp = _.values(obj.resp)
                        var arr_orig = _.values(obj.orig)
                        node_info.selectAll('.node_l7').remove();
                        if (d3.select(elm).classed("expand")) {
                            d3.selectAll(".node_sidebar").classed("expand", null)
                        } else if ((arr_resp.length > 0) || (arr_orig.length > 0)) {
                            d3.selectAll(".node_sidebar").classed("expand", null)
                            d3.select(elm).classed("expand", true)
                            let l7_table = d3.select(elm).append("div").classed("l7_table", true).append("table").classed("node_l7", true)
                            let l7_table_title = l7_table.append("tr").on("click", d3.event.stopPropagation())
                            l7_table_title.append("th").text("Dir")
                            l7_table_title.append("th").text("L7 App")
                            l7_table_title.append("th").text("Proto")
                            l7_table_title.append("th").text("Service")
                            l7_table_title.append("th").text("BW")
                            append_l7("Resp", l7_table, arr_resp, sel_ip, node.ip);
                            append_l7("Orig", l7_table, arr_orig, node.ip, sel_ip);
                        } else {
                            lmCtrl.nodeClicked(node);
                        }
                    }

                    function append_l7(type, elm, arr, resp_ip, orig_ip) {
                        let append_l7 = elm.selectAll('.l7_rows')
                            .data(arr).enter()
                            .append("tr")
                            .classed('l7_rows', true)
                            .on("click", d => {
                                d3.event.stopPropagation();
                                addAllToFilter(d.l7, d.proto, d.service, resp_ip, orig_ip)
                            })
                        append_l7.append("td").text(type)
                        append_l7.append("td").text(d => (d.l7 === "N/A" ? "-" : d.l7))
                        append_l7.append("td").text(d => (d.proto === "N/A" ? "-" : d.proto))
                        append_l7.append("td").text(d => (d.service === "N/A" ? "-" : d.service))
                        append_l7.append("td").text(d => (Math.round((d.bytes/$scope.diff_bandwidth[$scope.bandwidth].value)*1000) / 1000) + " " +$scope.diff_bandwidth[$scope.bandwidth].acronym)
                    }

                    function addAllToFilter(l7,proto,service,resp_ip,orig_ip) {
                        lmCtrl.main.clearFilters();
                        $scope.$apply(function () {
                            if (l7) {
                                addToFilterList("include", l7, 'l7_app', "Layer 7 Application")
                            }
                            if (proto) {
                                addToFilterList("include", proto, 'proto', "Protocol")
                            }
                            if (service) {
                                addToFilterList("include", service, 'service', "Service")
                            }
                            if (resp_ip) {
                                addToFilterList("include", resp_ip, 'resp_ip', "Responder IP")
                            }
                            if (orig_ip) {
                                addToFilterList("include", orig_ip, 'orig_ip', "Origin IP")
                            }
                        })
                    }

                    // adds L7 filters to the search bar to be used to send to the search page (does not actually filter on nodes)
                    function addToFilterList(action, value, column, columnTitle) {
                        lmCtrl.main.addFilter(column, value, action, true, columnTitle);
                    }

                    // draws the sidebar info list, only shows number of max rows, and connecting node once selected
                    lmCtrl.drawSidebar = function () {
                        let count = 0;
                        let sidebar_nodes = lmCtrl.nodes;
                        sidebar_nodes = lmCtrl.nodes.filter((d) => {
                            if (($scope.max_rows !== "false") && (count >= $scope.max_rows)) return false;
                            if ((d.visible) && (!d.grey)) {
                                count++;
                                return !d.selected;
                            }
                        })
                        node_info.selectAll('.node_sidebar').remove();
                        let node_sidebar = node_info.selectAll('.node_sidebar').data(sidebar_nodes)
                        node_sidebar = node_sidebar.enter()
                            .append("div")
                            .classed('node_sidebar', true)
                            .on("click", function (d) {
                                if (($scope.selected_nodes.length == 1) && (!lmCtrl.ctrlKey)) {
                                    between_two(this, d)
                                } else {
                                    d.selected = true;
                                    lmCtrl.nodeClicked(d);
                                }
                            })
                        let node_list = node_sidebar.append("div")
                            .classed('node_list', true)
                        node_list.append("span").classed("nl_type",true)
                            // .style("opacity", d => (d.grey) ? "0.25" : "1") dont need this since we hide non-connecting nodes
                            .style("background-color", d => {
                                return "none";
                                // if (d.collapse) {
                                //     if (d.action === "ioc") return lmCtrl.color(d.ioc)
                                //     if (d.group.length === 1) return lmCtrl.color(d.group[0])
                                //     return "#333"
                                // }
                                // return lmCtrl.color(d.group)
                            })
                            .append("svg")
                                .attr("width", "25px")
                                .attr("height", "25px")
                                .attr('transform', "translate(0,0)scale(1)")
                                    .append('path')
                                    .attr('transform',  d => {
                                        if (d.collapse) return svg_translate_sidebar(d.action)
                                        return svg_translate_sidebar(d.type)
                                    })
                                    .attr('d', d => {
                                        if (d.collapse) return lmCtrl.svgType(d.action);
                                        return lmCtrl.svgType(d.type);
                                    })
                                    .attr('fill', d => {
                                        if (d.collapse) {
                                            if (d.action === "ioc") return lmCtrl.color(d.ioc)
                                            if (d.group.length === 1) return lmCtrl.color(d.group[0])
                                            return "#333"
                                        }
                                        return lmCtrl.color(d.group)
                                    })
                        node_list.append("span").classed("nl_ip", true).text(d => {
                            if (d.collapse) return ((d.ip.length === 1) ? "1 Node" : d.ip.length + " Nodes")
                            return d.ip
                        })
                        node_list.append("span").classed("nl_hostname", true).text(d => {
                            if (d.collapse) return "Collapsed Node"
                            return ((d.hostname == 'N/A') ? "-" : d.hostname)
                        })
                        node_list.append("span").classed("nl_conn_count", true).text(d => { if (!d.collapse) return d.weight })
                    }
                    // SVGs in the node info list all need different transition
                    function svg_translate_sidebar(type) {
                        switch(type) {
                            case 'Switch':
                                return 'translate(1,4)scale(0.9)';
                            case 'Server':
                            case 'DNS Server':
                                return 'translate(3,5)scale(0.75)';
                            case 'Domain Controller':
                                return 'translate(4,5)scale(0.2)';
                            case 'File Server':
                                return 'translate(2,5)scale(0.85)';
                            case 'Database':
                                return 'translate(5,5)scale(0.02)';
                            case 'Web Server':
                                return 'translate(2,4)scale(0.85)';
                            case 'Mobile':
                                return 'translate(2,5)scale(0.8)';
                            case 'Laptop':
                                return 'translate(3,4)scale(0.8)';
                            case 'Desktop':
                                return 'translate(3,5)scale(0.75)';
                            case 'DHCP Server':
                                return 'translate(4,5)scale(0.85)';
                            case 'Endpoint':
                                return 'translate(1,4)scale(0.8)';
                            case 'type':
                            case 'cluster':
                            case 'new':
                            case 'Domain Controller':
                                return 'translate(1,3)scale(1)';
                            case 'Gateway':
                                return 'translate(0.5,2)scale(1)';
                            case 'Phone':
                                return 'translate(0,3)scale(1)';
                            case 'selected':
                            case 'connecting':
                                return 'translate(1,4)scale(1)';
                            case 'Printer':
                            case 'group':
                            case 'ioc':
                            case 'Access Point':
                                return 'translate(1,2)scale(1)';
                            default:
                                return 'translate(3,5)scale(0.8)';
                        }
                    }
                    // adds the IP to the search bar
                    $scope.addIpToSearch = function (ip) {
                        lmCtrl.main.clearFilters();
                        addToFilterList("include", ip, 'all', "All");
                    }

                // EDIT NODE - able to save node types and groups
                    // Saves the node info (group/type) depending what is set in the sidebar.
                    // It saves all the nodes that are selected
                    $scope.save_node = function (clear) {
                        let type = $scope.current.node.type;
                        let group = $scope.current.node.group;
                        if (clear) {
                            type = "N/A";
                            group = "N/A";
                        }
                        if (type === "new") {
                            type = "N/A";
                        }

                        if ((type == "false") && (group == "false")) {
                            alert('You need to at least select a type or group')
                        } else {
                            let selected_ips = [];
                            let already_exist = "(";
                            let new_nodes = $scope.selected_nodes.filter(d => {
                                if (d.collapse) {return false}
                                if (selected_ips.indexOf(d.ip) === -1) {
                                    selected_ips.push(d.ip);
                                }
                                if (!d.id) {
                                    if (type == "false") d.type = "N/A";
                                    if (group == "false") d.group = "N/A";
                                    return true;
                                } else {
                                    already_exist += "'"+d.ip+"',";
                                }
                            })
                            already_exist = _.trimEnd(already_exist, ",");
                            already_exist += ")";

                            let i;
                            for (i in lmCtrl.nodes_object) {
                                lmCtrl.nodes_object[i].selected = false;
                                lmCtrl.nodes_object[i].grey = false;
                                if ((_.indexOf(selected_ips, lmCtrl.nodes_object[i].ip) > -1) && (lmCtrl.nodes_object[i].visible) && (!lmCtrl.nodes_object[i].collapsed)) {
                                    if (!lmCtrl.nodes_object[i].id) lmCtrl.nodes_object[i].id = true;
                                    if (type != "false") lmCtrl.nodes_object[i].type = type;
                                    if (group != "false") lmCtrl.nodes_object[i].group = group;
                                }
                            }
                            if ((already_exist !== "()") || (new_nodes.length > 0)) {
                                lmCtrl.saveNodeInfo(type,group,already_exist,new_nodes);
                                $scope.current.node = {
                                    type: "false",
                                    group: "false"
                                }
                                lmCtrl.redraw();
                                $scope.selected_nodes = lmCtrl.getSelectedNodes();
                            }
                        }
                    }
                    // selects all the visible ndoes (etc. used for after a search)
                    $scope.selectAll = function () {
                        if ($scope.showSelectAll) {
                            $scope.showSelectAll = false;
                        } else {
                            $scope.showSelectAll = true;
                        }
                        let n;
                        for (n in lmCtrl.nodes_object) {
                            if (lmCtrl.nodes_object[n].visible) {
                                lmCtrl.nodes_object[n].selected = true;
                                lmCtrl.nodes_object[n].grey = false;
                            } else {
                                lmCtrl.nodes_object[n].selected = false;
                                lmCtrl.nodes_object[n].grey = false;
                            }
                        }
                        $scope.selected_nodes = lmCtrl.getSelectedNodes();
                        $scope.current.node.type = "false";
                        $scope.current.node.group = "false";
                        lmCtrl.redrawing();
                    }
                    $scope.unselectAll = function () {
                        if ($scope.showSelectAll) {
                            $scope.showSelectAll = false;
                        } else {
                            $scope.showSelectAll = true;
                        }
                        let n;
                        for (n in lmCtrl.nodes_object) {
                            lmCtrl.nodes_object[n].selected = false;
                            lmCtrl.nodes_object[n].grey = false;
                        }
                        $scope.selected_nodes = lmCtrl.getSelectedNodes();
                        $scope.current.node.type = "N/A";
                        $scope.current.node.group = "N/A";
                        lmCtrl.redrawing();
                    }

                // GROUP CREATION - able to create/edit/delete groups
                    // sets the selected group
                    $scope.group_selected = function (d) {
                        let group = angular.copy($scope.groups[$scope.current.selected]);
                        $scope.current.group.id = group.id;
                        $scope.current.group.name = group.name;
                        $scope.current.group.color = group.color;
                    }

                    // Obviously clears the group (used if you selected a group then decide you want to create a new one)
                    $scope.clear_group = function () {
                        clear_group()
                    }
                    function clear_group() {
                        $scope.current.selected = "";
                        $scope.current.group.id = false;
                        $scope.current.group.name = "";
                        $scope.current.group.color = "#000000";
                    }

                    // This is used to create/edit a group, if it is editing a group, it will re save all the nodes that is part of that group
                    // TODO: if save by ID can remove the associated ones (gotta figure out is saving by ID or name)
                    $scope.create_group = function () {
                        if ($scope.current.group.name !== "") {
                            let associated_nodes = nodes_associated();
                            if (associated_nodes) {
                                lmCtrl.editAssociatedGroups(associated_nodes, $scope.current.group.id);
                            }
                            lmCtrl.createEditGroup($scope.current.group, function (id) {
                                if (id) {
                                    $scope.groups[id] = angular.copy($scope.current.group)
                                    $scope.groups[id].id = id
                                } else {
                                    $scope.groups[$scope.current.group.id] = angular.copy($scope.current.group);
                                }
                                clear_group();
                                lmCtrl.redraw();
                            });
                        }
                    }
                    // this will delete a group, and if that group is assigned to a node it will remove (set it to null)
                    $scope.delete_group = function () {
                        let associated_nodes = nodes_associated();
                        if (associated_nodes) {
                            lmCtrl.editAssociatedGroups(associated_nodes, null);
                        }
                        lmCtrl.deleteGroup($scope.current.group.id);
                        delete $scope.groups[$scope.current.group.id]
                        clear_group();
                        lmCtrl.redraw();
                    }
                    // returns a string array of all the associated IPs to a group, used cassandra string (ex: where ip in ('nodes_associated'))
                    function nodes_associated() {
                        if (!$scope.current.group.id) {
                            return false;
                        }
                        let allGroupNodes = "(";
                        let a, match = false;
                        for (a in lmCtrl.allNodes) {
                            if (lmCtrl.allNodes[a].group === $scope.current.group.id) {
                                match = true;
                                allGroupNodes += "'"+lmCtrl.allNodes[a].ip+"',";
                            }
                        }
                        if (!match) {
                            return false;
                        }
                        allGroupNodes = _.trimEnd(allGroupNodes, ",");
                        return allGroupNodes += ")";
                    }

                // FILTER
                    // TODO: for future

                // COLLAPSE - able to select, collapse, hide, show nodes depending on what you chose (IOC, type, group, cluster, selected, or connecting nodes)
                    let collapse_toggle = d3.select("#collapse_toggle")
                        .attr('transform', 'translate(0, 0)')
                        .attr("width",lmCtrl.sidebar_width-(background_radius*2))
                        .attr("height","65")

                    let collapse_line = collapse_toggle.append("path")
                        .classed("slider_line", true)
                        .attr("transform","translate(5, 0)")
                        .attr("d","M5 20 l"+max_x+" 0")

                    let collapse_select = collapse_toggle.selectAll('.select_circles').data(circles_collapse).enter().append("g")
                        .classed("select_circles", true)
                        .classed("selected", function (d) {
                            if (collapse_hide === d.value) return true
                            return null
                        })
                        .attr('transform', (d) => 'translate('+d.offsetX+', '+(background_radius+2)+')')
                        .on("click", function (d) {
                            collapse_toggle.selectAll('.select_circles').classed("selected", null)
                            collapse_hide = d.value;
                            d3.select(this).classed("selected", true)
                        });

                    collapse_select.append("circle")
                        .attr("r", background_radius)

                    collapse_select.append("text")
                        .classed("slider_collapse_text", true)
                        .attr('transform', 'translate(0, 0)')
                        .attr("y", ((background_radius*2)-3))
                        .text(d => d.name)
                    // select, collapse, hide, show all IOCs
                    $scope.show_hide_ioc = function (action) {
                        let n, arr = [];
                        for (n in lmCtrl.nodes_object) {
                            if (lmCtrl.nodes_object[n].visible) {
                                if (lmCtrl.nodes_object[n].ioc > 0) {
                                    arr = _.uniq(_.concat(arr,lmCtrl.nodes_object[n].ip))
                                }
                            }
                        }
                        if (arr.length === 0) {
                            alert("There are no IOCs")
                            return;
                        }
                        switch (collapse_hide) {
                            case 3:
                                showOnlyIOC(arr);
                                break;
                            case 2:
                                hideIOC(arr);
                                break;
                            case 1:
                                let newNode = angular.copy(defaultCollapsedNode);
                                newNode.action = "ioc";
                                newNode.id = guid();
                                newNode = lmCtrl.newNode(newNode);
                                lmCtrl.nodes_object[newNode.id] = newNode;
                                let n;
                                for (n in lmCtrl.nodes_object) {
                                    if (!lmCtrl.nodes_object[n].collapse) {
                                        if ((lmCtrl.nodes_object[n].ioc > 0) && (_.indexOf(lmCtrl.already_collapsed_ips,lmCtrl.nodes_object[n].ip) === -1)) {
                                            collapse_to_node(newNode, n);
                                        }
                                    }
                                }
                                break;
                            default:
                                selectIOC(arr);
                                break;
                        }
                        lmCtrl.redraw();
                    }
                    // select, collapse, hide, show all selected IPs depending and what is clicked
                        // It can be 'grouped' on type, group, cluster, selected, connecting
                    $scope.collapse = function (action) {
                        $scope.selected_nodes = lmCtrl.getSelectedNodes();
                        let n = $scope.selected_nodes.length, arr = [], by = "";;
                        if (n === 0) {
                            return;
                        }
                        switch (action) {
                            case "selected":
                                by = 'ip';
                                break;
                            case "type":
                                by = 'type';
                                break;
                            case "group":
                                by = 'group';
                                break;
                            case "cluster":
                                by = 'ip';
                                break;
                            case "connecting":
                                by = 'ip';
                                break;
                        }

                        while (n--) {
                            if (!$scope.selected_nodes[n].collapse) {
                                if (action === "connecting") {
                                    arr = _.uniq(_.concat(arr,$scope.selected_nodes[n].ip))
                                    arr = _.uniq(_.concat(arr,lmCtrl.nodes_object[$scope.selected_nodes[n][by]].connections))
                                } else if (action === "cluster") {
                                    arr = _.uniq(_.concat(arr,$scope.selected_nodes[n][by]))
                                    arr = goDownTree($scope.selected_nodes[n][by], arr);
                                } else {
                                    arr = _.uniq(_.concat(arr,$scope.selected_nodes[n][by]))
                                }
                            }
                        }
                        if (_.includes(arr, "N/A")) {
                            arr = _.uniq(_.concat(arr, null))
                        }
                        if (_.includes(arr, null)) {
                            arr = _.uniq(_.concat(arr, "N/A"))
                        }

                        switch (collapse_hide) {
                            case 3:
                                showOnly(by, arr);
                                break;
                            case 2:
                                hide(by, arr);
                                break;
                            case 1:
                                collapse(by, arr, action);
                                break;
                            default:
                                select(by, arr);
                                break;
                        }
                        $scope.selected_nodes = lmCtrl.getSelectedNodes();
                        $scope.current.node = {
                            type: "false",
                            group: "false"
                        }
                        lmCtrl.redraw();
                    }
                    // recursive function that and array for all the nodes in a cluster
                    function goDownTree(ip, arr) {
                        var a;
                        for (a in lmCtrl.nodes_object[ip].connections) {
                            if (arr.indexOf(lmCtrl.nodes_object[ip].connections[a]) === -1) {
                                arr.push(lmCtrl.nodes_object[ip].connections[a])
                                goDownTree(lmCtrl.nodes_object[ip].connections[a], arr);
                            }
                        }
                        return arr;
                    }
                    // genereates a random ID for the collapsed node to use as key in the nodes_object
                    function guid() {
                        function s4() {
                            return Math.floor((1 + Math.random()) * 0x10000)
                              .toString(16)
                              .substring(1);
                        }
                        return s4() + s4() + s4();
                    }
                    // collapses all the nodes associated to the collapsed node (also hides it when it is 'put' in the collapsed node)
                    function collapse_to_node(newNode, n) {
                        lmCtrl.nodes_object[n].visible = false;
                        lmCtrl.already_collapsed_ips = _.uniq(_.concat(lmCtrl.already_collapsed_ips,n));
                        newNode.ip = _.uniq(_.concat(newNode.ip,n));
                        newNode.connections = _.uniq(_.concat(newNode.connections,lmCtrl.nodes_object[n].connections));
                        newNode.resp_l7 = _.uniq(_.concat(newNode.resp_l7,lmCtrl.nodes_object[n].resp_l7));
                        newNode.orig_l7 = _.uniq(_.concat(newNode.orig_l7,lmCtrl.nodes_object[n].orig_l7));
                        newNode.group = _.uniq(_.concat(newNode.group,lmCtrl.nodes_object[n].group));
                        newNode.type = _.uniq(_.concat(newNode.type,lmCtrl.nodes_object[n].type));
                        newNode.hostname = _.uniq(_.concat(newNode.hostname,lmCtrl.nodes_object[n].hostname));
                        newNode.mac = _.uniq(_.concat(newNode.mac,lmCtrl.nodes_object[n].mac));
                        newNode.os = _.uniq(_.concat(newNode.os,lmCtrl.nodes_object[n].os));
                        newNode.vendor = _.uniq(_.concat(newNode.vendor,lmCtrl.nodes_object[n].vendor));
                        newNode.ioc = Math.max(newNode.ioc, lmCtrl.nodes_object[n].ioc);
                        if ($scope.groups[lmCtrl.nodes_object[n].group]) {
                            newNode.group_name = _.uniq(_.concat(newNode.group_name,$scope.groups[lmCtrl.nodes_object[n].group].name));
                        } else {
                            newNode.group_name = _.uniq(_.concat(newNode.group_name,"N/A"));
                        }
                        // ADD COLLAPSED NODE TO CONNECTIONS
                        for (let a in lmCtrl.nodes_object[n].connections) {
                            if (lmCtrl.nodes_object[lmCtrl.nodes_object[n].connections[a]].visible)  {
                                if (!lmCtrl.allLinks[newNode.id+"-"+lmCtrl.nodes_object[lmCtrl.nodes_object[n].connections[a]].ip]) {
                                    lmCtrl.allLinks[newNode.id+"-"+lmCtrl.nodes_object[lmCtrl.nodes_object[n].connections[a]].ip] = true;
                                    let newLink = lmCtrl.newLink(newNode,lmCtrl.nodes_object[lmCtrl.nodes_object[n].connections[a]]);
                                    lmCtrl.links.push(newLink)
                                }
                            }
                        }
                    }
                    // once an array is made, all the nodes in that array will be hidden and all the information will be passed to this new collapsed node
                    function collapse(by, arr, action) {
                        if (arr.length > 0) {
                            let newNode = angular.copy(defaultCollapsedNode);
                            newNode.action = action;
                            newNode.id = guid();
                            newNode = lmCtrl.newNode(newNode);
                            lmCtrl.nodes_object[newNode.id] = newNode;
                            let n;
                            for (n in lmCtrl.nodes_object) {
                                lmCtrl.nodes_object[n].selected = false;
                                lmCtrl.nodes_object[n].grey = false;
                                if (!lmCtrl.nodes_object[n].collapse) {
                                    if ((_.indexOf(arr,lmCtrl.nodes_object[n][by]) > -1) && (_.indexOf(lmCtrl.already_collapsed_ips,n) === -1)) {
                                        collapse_to_node(newNode, n);
                                    }
                                } else { // if collapsed node
                                    if (lmCtrl.nodes_object[n].visible && newNode.visible) {
                                        if ((_.intersection(lmCtrl.nodes_object[n].connections, newNode.ip)).length > 0) {
                                            if (!lmCtrl.allLinks[newNode.id+"-"+lmCtrl.nodes_object[n].ip]) {
                                                lmCtrl.allLinks[newNode.id+"-"+lmCtrl.nodes_object[n].ip] = true;
                                                let newLink = lmCtrl.newLink(newNode,lmCtrl.nodes_object[n]);
                                                lmCtrl.links.push(newLink)
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    // once an array is made, only the nodes in that array will be shown, hidding the rest
                    function showOnlyIOC(arr) {
                        let n;
                        for (n in lmCtrl.nodes_object){
                            if (lmCtrl.nodes_object[n].visible) {
                                if (_.indexOf(arr, lmCtrl.nodes_object[n].ip) > -1) {
                                    lmCtrl.nodes_object[n].visible = true;
                                } else {
                                    lmCtrl.nodes_object[n].visible = false;
                                }
                            }
                        }
                    }
                    // once an array is made, all the nodes in that array will be hidden, showing the rest of the nodes
                    function hideIOC(arr) {
                        let n;
                        for (n in lmCtrl.nodes_object){
                            if (lmCtrl.nodes_object[n].visible) {
                                if (_.indexOf(arr, lmCtrl.nodes_object[n].ip) > -1) {
                                    lmCtrl.nodes_object[n].visible = false;
                                }
                            }
                        }
                    }
                    // once an array is made, all the nodes in that array will be selected, unselecting the rest
                    function selectIOC(arr) {
                        let n;
                        for (n in lmCtrl.nodes_object){
                            if (lmCtrl.nodes_object[n].visible) {
                                if (_.indexOf(arr, lmCtrl.nodes_object[n].ip) > -1) {
                                    if (lmCtrl.nodes_object[n].ioc > 0) {
                                        lmCtrl.nodes_object[n].selected = true;
                                    } else {
                                        lmCtrl.nodes_object[n].selected = false;
                                    }
                                } else {
                                    lmCtrl.nodes_object[n].selected = false;
                                }
                            }
                        }
                        lmCtrl.greyOut();
                    }
                    // once an array is made, only the nodes in that array will be shown, hidding the rest
                    function showOnly(by, arr) {
                        if (arr.length > 0) {
                            let n;
                            for (n in lmCtrl.nodes_object){
                                lmCtrl.nodes_object[n].selected = false;
                                lmCtrl.nodes_object[n].grey = false;
                                if (_.indexOf(arr,lmCtrl.nodes_object[n][by]) === -1) {
                                    lmCtrl.nodes_object[n].visible = false;
                                }
                            }
                        }
                    }
                    // once an array is made, all the nodes in that array will be hidden, showing the rest of the nodes
                    function hide(by, arr) {
                        if (arr.length > 0) {
                            let n;
                            for (n in lmCtrl.nodes_object){
                                lmCtrl.nodes_object[n].selected = false;
                                lmCtrl.nodes_object[n].grey = false;
                                if (_.indexOf(arr,lmCtrl.nodes_object[n][by]) > -1) {
                                    lmCtrl.nodes_object[n].visible = false;
                                }
                            }
                        }
                    }
                    // once an array is made, all the nodes in that array will be selected, unselecting the rest
                    function select(by, arr) {
                        if (arr.length > 0) {
                            let n;
                            for (n in lmCtrl.nodes_object){
                                if (lmCtrl.nodes_object[n].visible) {
                                    if (_.indexOf(arr,lmCtrl.nodes_object[n][by]) > -1) {
                                        lmCtrl.nodes_object[n].selected = true;
                                    }
                                }
                            }
                        }
                        lmCtrl.greyOut()
                    }
                    // resets the nodes back to when it had its original load
                    $scope.reset = function () {
                        lmCtrl.nodes = lmCtrl.nodes.filter(d => typeof d.ip !== "object");
                        lmCtrl.links = lmCtrl.links.filter(d => ((typeof d.source.ip !== "object") && (typeof d.target.ip !== "object")));
                        resetAllNodes();
                        lmCtrl.main.clearFilters();
                        $scope.selected_nodes = lmCtrl.getSelectedNodes();
                        $scope.current.node = {
                            type: "N/A",
                            group: "N/A"
                        }
                    }

                    // resets all the nodes to its original nodes array, removing any collapsed node, making all visible, none grey, not selected and not fixed
                    function resetAllNodes() {
                        lmCtrl.already_collapsed_ips = [];
                        let no;
                        for (no in lmCtrl.nodes_object) {
                            if (lmCtrl.nodes_object[no].collapse) {
                                delete lmCtrl.nodes_object[no];
                            } else {
                                lmCtrl.nodes_object[no].selected = false;
                                lmCtrl.nodes_object[no].visible = true;
                                lmCtrl.nodes_object[no].grey = false;
                                lmCtrl.nodes_object[no].fixed = false;
                            }
                        }
                        lmCtrl.redraw();
                    }

                // SETTINGS - Able to change the forcechart settings depending on what structure your node tree looks like, every network can have different settings
                    // all the following can be changed and saved as local settings for the next time that KEYSPACE uses the page
                        // - gravity, charge, link distance, link strength, friction, sidebar node info limit, what units L7 bandwidth to be shown
                    // can also freeze / unfreeze the chart
                    // can also reset the original default settings
                    var slider_drag = d3.drag()
                        .subject(Object)
                        .on("drag", drag_slider)
                        .on('end', drag_slider_end);

                    let slider_settings = d3.select("#slider_settings")
                        .attr('transform', 'translate(0, 0)')
                        .attr('width', lmCtrl.sidebar_width-(offsetX*2))
                        .attr('height', (49*sliders.length))

                    // creates all the sliders from the sliders array
                    let slider = slider_settings.selectAll('.linkSlider').data(sliders).enter().append("g")
                        .classed("linkSlider", true)
                        .attr('transform', (d,i) => 'translate('+slider_radius+', '+(offsetY*(i)+slider_height)+')');

                    let slider_text = slider.append("text")
                        .classed("slider_text", true)
                        .attr('transform', 'translate(0, 0)')
                        .text(d => d.name.replace("_"," "))

                    let slider_line = slider.append("path")
                        .classed("domain", true)
                        .attr('transform', 'translate(0, '+slider_height+')')
                        .attr("d","M0,0V0H"+max_x+"V0");

                    let slider_circle = slider.append("g")
                        .classed("slider", true)
                        .attr('transform', 'translate(0,'+slider_height+')')
                        .append("circle")
                            .attr("class", d => "handle "+d.name)
                            .attr("r",slider_radius)
                            .attr("cy","0")
                            .attr("cx",d => {
                                if (d.name === "charge") {
                                    d.x = max_x*d.default/d.min
                                } else {
                                    d.x = max_x*d.default/d.max
                                }
                                return d.x;
                            })
                            .call(slider_drag);

                    // once you drag a slider, is has to change its X value, and set/save the new settings
                    function drag_slider(d) {
                        d.x = Math.max(0, Math.min(lmCtrl.sidebar_width-(offsetX*4), d3.event.x))
                        // if (d.name !== "charge") {
                        //     if (d.x === 0) {
                        //         d.x = d.min;
                        //     }
                        // }
                        set_setting(d)
                        d3.select(this).attr("cx", d.x)
                    }
                    // sets the new settings to the force chart
                    function set_setting(setting) {
                        switch(setting.name) {
                            case 'gravity':
                                lmCtrl.gravity = setting.x/max_x*setting.max + setting.min;
                                break;
                            case 'charge':
                                lmCtrl.charge = setting.x/max_x*setting.min + setting.max;
                                break;
                            case 'link_distance':
                                lmCtrl.link_distance = setting.x/max_x*setting.max + setting.min;
                                break;
                            case 'link_strength':
                                lmCtrl.link_strength = setting.x/max_x*setting.max + setting.min;
                                break;
                            case 'friction':
                                lmCtrl.friction = setting.x/max_x*setting.max + setting.min;
                                break;
                            case 'padding':
                                lmCtrl.padding = setting.x/max_x*setting.max + setting.min;
                                break;
                            // case 'alpha':
                            //     lmCtrl.alpha = setting.x/max_x*setting.max;
                            //     break;
                            // case 'radius':
                            //     lmCtrl.maxRadius = setting.x/max_x*setting.max;
                            //     break;
                            default:
                                return;
                        }
                        lmCtrl.resetInternalMap();
                    }
                    // onces released it saves the new settings localy
                    function drag_slider_end(d) {
                        lmCtrl.settings.set('lateral_chart_settings', [lmCtrl.gravity,lmCtrl.charge,lmCtrl.link_distance,lmCtrl.link_strength,lmCtrl.friction,lmCtrl.padding]) //,lmCtrl.alpha,lmCtrl.maxRadius
                    }

                    let freeze = slider_settings.append("g")
                        .classed("slider_buttons", true)
                        .attr('transform', 'translate('+(40*0)+', '+(42*sliders.length)+')scale(1.5)')
                    freeze.append("path")
                            .attr("fill", "#4A95CF")
                            .attr("d", "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v"+
                                    "2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z");
                    freeze.append("rect")
                        .classed("unfreeze", true)
                        .classed("hide_section", null)
                        .attr("fill", "#C4150D")
                        .attr("x", -1.14)
                        .attr("y", 11)
                        .attr("width", 26.28)
                        .attr("height", 2)
                        .attr("transform", "translate(-5, 15)rotate(-55)");

                    freeze.append("rect")
                        .attr("fill", "transparent")
                        .attr("width", 30)
                        .attr("height", 30)
                        .on("click", function () {
                            if (d3.select(".unfreeze").classed("hide_section")) {
                                d3.select(".unfreeze").classed("hide_section", null)
                                d3.select(this).select('title').html("Unreeze Graph");
                                freeze_graph(false);
                            } else {
                                d3.select(".unfreeze").classed("hide_section", true)
                                d3.select(this).select('title').html("Freeze Graph");
                                freeze_graph(true);
                            }
                        }).append('title').html("Unfreeze Graph");
                    function freeze_graph(val) {
                        let n, len;
                        for (n in lmCtrl.nodes_object) {
                            lmCtrl.nodes_object[n].fixed = val;
                        }
                        lmCtrl.redraw();
                    }

                    let reset_chart = slider_settings.append("g")
                        .classed("slider_buttons", true)
                        .attr('transform', 'translate('+(40*1)+', '+(42*sliders.length)+')scale(1.5)')
                    reset_chart.append("path")
                        .attr("fill", "#CF2974")
                        .attr("d", "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z")
                    reset_chart.append("rect")
                        .attr("fill", "transparent")
                        .attr("width", 30)
                        .attr("height", 30)
                        .on("click", function () {
                            freeze_graph(false);
                            reset_graph();
                            lmCtrl.settings.set('lateral_chart_settings', false)
                        })
                        .append('title').html("Reset Settings");
                    // resets the chart to the default original settings, and also draws the sliders accordingly
                    function reset_graph() {
                        lmCtrl.gravity = 0.05,
                        lmCtrl.charge = -10,
                        lmCtrl.link_distance = 80,
                        lmCtrl.link_strength = 0.5,
                        lmCtrl.friction = 0.6;
                        lmCtrl.padding = 2;
                        let obj = {
                            gravity : lmCtrl.gravity,
                            charge : lmCtrl.charge,
                            link_distance : lmCtrl.link_distance,
                            link_strength : lmCtrl.link_strength,
                            friction : lmCtrl.friction,
                            padding : lmCtrl.padding,
                        }
                        // lmCtrl.resetInternalMap();
                        d3.select(".unfreeze").classed("hide_section", null)
                        lmCtrl.redraw();
                        slider_circle.attr("cx", function (d) {
                            if (d.name === "charge") {
                                d.x = max_x*obj[d.name] / d.min
                            } else {
                                d.x = max_x*obj[d.name] / d.max
                            }
                            return d.x;
                        })
                    }


                    let realign_map = slider_settings.append("g")
                        .classed("slider_buttons", true)
                        .attr('transform', 'translate('+(40*2)+', '+(42*sliders.length)+')scale(1.5)')
                    realign_map.append("path")
                        .attr("fill", "#422069")
                        .attr("d", "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z")
                    realign_map.append("rect")
                        .attr("fill", "transparent")
                        .attr("width", 30)
                        .attr("height", 30)
                        .on("click", function () {
                            lmCtrl.realign_map();
                        })
                        .append('title').html("Realign Map");


                    // when you pick the max rows for sidebar node info, it then saves it localy
                    $scope.max_row_selected = function () {
                        if ($scope.max_rows === "false") {
                            lmCtrl.settings.set('lateral_chart_max_rows', false)
                        } else {
                            lmCtrl.settings.set('lateral_chart_max_rows', $scope.max_rows)
                        }
                        lmCtrl.drawSidebar();
                    }

                    // when you pick the bandwidth units for L7 sidebar node info, it then saves it localy
                    $scope.bandwidth_selected = function () {
                         if ($scope.bandwidth === "b") {
                            lmCtrl.settings.set('lateral_chart_bandwidth', false)
                        } else {
                            lmCtrl.settings.set('lateral_chart_bandwidth', $scope.bandwidth)
                        }
                        lmCtrl.drawSidebar();
                    }
                    // when you pick the bandwidth units for L7 sidebar node info, it then saves it localy
                    $scope.display_text = function (val) {
                        if (val === "ip") {
                            if ($scope.display_ip === "true") {
                                lmCtrl.settings.set('display_ip', false);
                            } else {
                                lmCtrl.settings.set('display_ip', $scope.display_ip);
                            }
                        } else if (val === "hostname") {
                            if ($scope.display_hostname) {
                                lmCtrl.settings.set('display_hostname', $scope.display_hostname);
                            } else {
                                lmCtrl.settings.set('display_hostname', false);
                            }
                        } else if (val === "search") {
                            if ($scope.hide_on_search) {
                                lmCtrl.settings.set('hide_on_search', $scope.hide_on_search);
                            } else {
                                lmCtrl.settings.set('hide_on_search', false);
                            }
                            $scope.reset();
                        }
                    }
            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

            //////////////////
            /// POPUP INFO ///
            //////////////////
                let popup_click = d3.select("#click_popup")
                let popup = d3.select("#popup")
                let overlay = d3.select(".overlay")
                let popup_stop = d3.select(".popup")
                let popup_close = d3.select("#popup_close")

                popup_stop.on("click", d => {
                    d3.event.stopPropagation();
                })
                popup_click.on("click", popup_func)
                popup_close.on("click", popup_func)
                overlay.on("click", popup_func)

                function popup_func() {
                    if (popup.classed("hidden")) {
                        popup.classed("hidden", null);
                    } else {
                        popup.classed("hidden", true);
                    }
                }
            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

            ///////////////////
            /// RESIZE PAGE ///
            /////////////////// --------------------------------------------------------------------------------------------------------------------------------------------------------------
                function resize_sidebar() {
                    lmCtrl.max_width = element[0].clientWidth, lmCtrl.height = angular.element($window)[0].innerHeight-150;
                    lmCtrl.width = lmCtrl.max_width*0.76;
                    lmCtrl.sidebar_width = lmCtrl.max_width*0.22;
                    lmCtrl.tempWidth = lmCtrl.width;
                    old_max_x = max_x;
                    max_x = (lmCtrl.sidebar_width-(offsetX*4));
                    circles_collapse = [ // have to re-position the circles for the collapsed section
                        {value:0, name: "Select", offsetX:background_radius+2},
                        {value:1, name: "Collapse", offsetX:((max_x/3)+(background_radius))},
                        {value:2, name: "Hide", offsetX:(((max_x*2)/3)+(background_radius/2))},
                        {value:3, name: "Show", offsetX:(max_x)},
                    ]
                    slider_settings.attr('width', lmCtrl.sidebar_width-(offsetX*2))
                    sidebar.style("max-width",lmCtrl.sidebar_width+"px")
                    sidebar_svg.attr("width",lmCtrl.sidebar_width)
                    slider_line.attr("d","M0,0V0H"+max_x+"V0");
                    collapse_toggle.attr("width", lmCtrl.sidebar_width-(background_radius*2))
                    collapse_line.attr("d","M5 20 l"+max_x+" 0");
                    collapse_toggle.selectAll('.select_circles').data(circles_collapse).attr('transform', (d) => 'translate('+d.offsetX+', '+(background_radius+2)+')')
                    slider_circle.attr("cx", d => d.x = (max_x/old_max_x)*d.x)
                    sidebar_content.style("max-height", (lmCtrl.height-50)+"px")
                    if (sidebar.classed("hide_section")) {
                        lmCtrl.width = lmCtrl.max_width-80;
                    } else {
                        lmCtrl.width = lmCtrl.tempWidth;
                    }
                }
                lmCtrl.resize_sb = function () {
                    resize_sidebar()
                }

                angular.element($window).bind('resize', () => {
                    // Event that happens whenever the window is resized
                    lmCtrl.waitForFinalEvent(() => {
                        resize_sidebar();
                    }, 250, "sidebar_resize");
                });
                    angular.element(document).ready(function () {
                       console.log($window.innerWidth);
                       if($window.innerWidth <= 1360)
                            $scope.toggleSidebar('sidebar');
                    });
            // ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^

            // clear timers on scope destroy
            $scope.$on('$destroy', function () {
                element = null;
                angular.element($window).unbind('resize')
            });
        }
    };
}

directive.$inject = ['$window', 'timeFormat', '$state', '$stateParams'];
module.exports = directive;



/** WEBPACK FOOTER **
 ** ./src/pages/directives/lateralmap/lm_sidebar.js
 **/